import { app } from '@microsoft/teams-js';
import { endAndReportPerformanceMeasure, startPerformanceMeasure } from '@ms/yammer-data/dist/telemetry';

type EnsureInitializedWithTelemetry = () => Promise<void>;
export const ensureInitializedWithTelemetry: EnsureInitializedWithTelemetry = async () => {
  if (!app.isInitialized()) {
    let endedWithError = false;
    const measure = startPerformanceMeasure('meta_os_hub_initialize');

    try {
      return await app.initialize();
    } catch (error) {
      endedWithError = true;
    } finally {
      endAndReportPerformanceMeasure({ ...measure, eventProperties: { endedWithError } });
    }
  }
};
